import React from 'react';
import { FileTextIcon, GiftIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
export function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="overflow-hidden rounded-2xl bg-white shadow-lg shadow-black/30" data-id="element-18" data-mp="2o5v6a6qvvyl2">
      <div className="flex items-center gap-3 border-b border-teal-800/10 px-4 py-3 md:px-5" data-id="element-19" data-mp="2t10wviv8e1fh">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-amber-400 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-teal-950 md:text-[11px]" data-id="element-20" data-mp="2x2mc3av8mrsu">
          <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-21" data-mp="25e2iqrul35kq" />
          Free Bonus {bonus.number}
        </span>
        <h3 className="text-sm font-black uppercase leading-tight text-teal-950 md:text-base" data-id="element-22" data-mp="29d1je09a8g6d">{bonus.name}</h3>
      </div>
      <div className="px-4 py-4 md:px-5" data-id="element-23" data-mp="1hnyfwmp7z9us">
        <p className="text-sm font-semibold leading-relaxed text-teal-950" data-id="element-24" data-mp="1hn6rpwxyceej">{bonus.summary}</p>
        <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-25" data-mp="1loib3kq8g3ea">{bonus.details}</p>
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3" data-id="element-26" data-mp="1x2ef7jciysxu">
          <p className="flex items-center gap-1.5 text-xs font-black uppercase tracking-wide text-teal-700" data-id="element-27" data-mp="1s3a7kx59139m">
            <FileTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-28" data-mp="1nbs7ebb1v6pp" />
            {bonus.pages}
          </p>
          <p className="flex items-center gap-2" data-id="element-29" data-mp="1ie0bl67ab0g8">
            <span className="text-sm font-black text-slate-500 line-through decoration-red-600 decoration-2" data-id="element-30" data-mp="1ib4etl76ahtd">
              ${bonus.value} USD
            </span>
            <span className="rounded-md bg-teal-800 px-3 py-1 text-xs font-black uppercase text-white" data-id="element-31" data-mp="19br3so3ehl6j">Free</span>
          </p>
        </div>
      </div>
    </article>;
}